module.exports = __webpack_public_path__ + "static/media/stefanija.2c93cf82.jpg";